angular.module('unica_survey.survey_services')

.factory('SurveyEditService', function ($http, getBaseApiURL) {

	var surveyEditService = {};

	surveyEditService.update = function (surveyData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/survey/update/' + surveyData.id,
			data: surveyData
		}).then(function(result) {

			if ( result ) {
				return result.data.survey;
			}

		});
	};

	return surveyEditService;
});